import { useEffect,useState } from 'react'
import { Card, CardContent, Grid } from '@mui/material'
import { post } from '../../utils/axios'

const Mission = () => {

    const [content,setContent] = useState('')

    useEffect(() => {
        const postedData = {
            key: 'mission'
        }
        post('Config/GetConfigByKey',postedData).then(({ data }) => {
            if(data.isSuccess)
                setContent(data.data.value)
        })
    },[])

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">ماموریت سازمان</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item">
                    <CardContent style={{ paddingBottom: 16 }}>
                        <p className="others-page-content">{content}</p>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default Mission